import React from "react";
import { MEDIA } from "../lib/media";
import { Reveal } from "../components/Reveal";

export default function MeghalayaStory() {
  return (
    <div>
      <section className="relative h-[80vh] min-h-[480px] flex items-center justify-center text-center overflow-hidden">
        <img src={MEDIA.hero} alt="Meghalaya" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-forest/40" />
        <Reveal className="relative text-ivory px-6 max-w-3xl">
          <span className="eyebrow text-ivory/80">The Meghalaya Story</span>
          <h1 className="serif text-5xl lg:text-7xl mt-4">Where Nature Breathes Differently</h1>
        </Reveal>
      </section>
      <div className="max-w-3xl mx-auto px-5 lg:px-10 py-24 text-center">
        <Reveal><p className="serif text-3xl lg:text-4xl leading-snug text-forest/80 mb-8">Hidden in the clouds of Northeast India lies Meghalaya — the abode of the clouds — a land of ancient forests, living root bridges, waterfalls and remarkable biodiversity.</p></Reveal>
        <Reveal delay={0.1}><p className="text-forest/65 leading-relaxed">Its harmony with nature inspires the world around us and shapes the philosophy behind IAH. We do not claim to bottle Meghalaya. Instead, we let its rhythm guide us — purity over excess, patience over shortcuts, and a deep respect for the natural world.</p></Reveal>
      </div>
      <div className="grid md:grid-cols-3 gap-2">
        {[MEDIA.waterfall, MEDIA.rootbridge, MEDIA.fern].map((s, i) => (
          <div key={i} className="overflow-hidden aspect-[3/4]"><img src={s} alt="" className="h-full w-full object-cover hover:scale-105 transition-transform duration-700" /></div>
        ))}
      </div>
    </div>
  );
}
